import React from "react";
import { Box, Typography } from "@mui/material";
import SearchOffIcon from "@mui/icons-material/SearchOff";

export const BottomNoData: React.FC = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        p: 3,
        textAlign: "center",
        color: "text.secondary",
      }}
    >
      <SearchOffIcon sx={{ fontSize: 48, mb: 1, color: "grey.500" }} />
      <Typography variant="h6" gutterBottom>
        Keine Daten verfügbar
      </Typography>
      <Typography variant="body2">
        Für den gewählten Zeitraum konnten keine Daten ermittelt werden.
      </Typography>
    </Box>
  );
};
